import { useEffect, useState } from 'react';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useQualiFactoryUpgradesCriteria } from '~/context/common/FactoryUpgradesQualiContext';
import { QUALI_FACTORY_UPGRADES_NAME } from '~/hooks/common/experiments/useIsInFactoryUpgradesQualiExperiment';
import useQualiModalCore, {
  SurveyConfig
} from '~/hooks/common/quali/useQualiModalCore';
import sendMessageToNative from '~/native/home/dispatchers/sendMessageToNative';

function useActiveSurvey(): SurveyConfig | undefined {
  const shouldOpenFactoryUpgradesSurvey = useQualiFactoryUpgradesCriteria();
  const [activeSurvey, setActiveSurvey] = useState<SurveyConfig | undefined>();

  useEffect(() => {
    if (activeSurvey) return;

    if (shouldOpenFactoryUpgradesSurvey) {
      setActiveSurvey({
        analyticsTitle: 'Factory Upgrades',
        delay: 5000,
        name: QUALI_FACTORY_UPGRADES_NAME,
        title: 'How do you like our new Factory Upgrades feature?'
      });
    }
  }, [activeSurvey, shouldOpenFactoryUpgradesSurvey]);

  return activeSurvey;
}

export default function useQualiModal() {
  const activeSurvey = useActiveSurvey();
  const trackEvent = useTrackEvent();

  useQualiModalCore({ activeSurvey, sendMessageToNative, trackEvent });
}
